import { cqAPI, getBid } from "../../lib/Auth";
import { Box, Flex, useColorMode, useToast, Button } from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import { AddIcon } from "@chakra-ui/icons";
import EditableText from "../EditableText/EditableText";
import { useNavigate } from 'react-router-dom';
import moment from "moment";

function History() {
  const toast = useToast();
  const bid = getBid();
  const [templates, setTemplates] = useState([]);
  const [activeTemplateId, setActiveTemplateId] = useState(null);
  const { colorMode } = useColorMode();
  const navigate = useNavigate();

  const fetchHistoryTemplate = async () => {
    const response = await cqAPI.get("/settings/history");
    setTemplates(response.data);
    const activeTemplate = response.data.find(template => template.active);
    if (activeTemplate) {
      setActiveTemplateId(activeTemplate._id);
    }
  };

  useEffect(() => {
    fetchHistoryTemplate();
  }, []);

  const updateTemplateField = async (template, field, value) => {
    const response = await cqAPI.put("/settings/history", {
      template_id: template._id,
      field,
      value,
    });
    if (response.type === "error") {
      if (response.msg) {
        toast({
          title: "Error updating the template.",
          description: response.msg,
          status: "error",
          duration: 9000,
          isClosable: true,
        });
      }
      return false;
    }
    await fetchHistoryTemplate();
    return true;
  };

  const makeTemplateActive = async (templateId) => {
    const response = await cqAPI.put("/settings/history/activate", {
      template_id: templateId
    });
    await fetchHistoryTemplate();
  };

  return (
    <Box
      p={4}
      overflowY="auto"
      maxHeight="100vh"
      width="100%"
      position="relative"
    >
      <Flex
        p={4}
        overflowY="auto"
        maxHeight="100vh"
        padding="8px 24px 24px 24px"
        height="95vh"
        bgColor={colorMode === "light" ? "#FFFFFF" : "#212330"}
        borderRadius="16px"
        flexDirection="column"
      >
        <Flex justifyContent="flex-end" mb={4}>
          <Button leftIcon={<AddIcon />} onClick={()=>{
            const newSearchParams = new URLSearchParams(
              window.location.search
            );
            navigate(`/settings/history/new?${newSearchParams.toString()}`)
          }}>Add Questionnaire</Button>
        </Flex>
        {templates.map((template, index) => (
          <Box
            className="template"
            key={template._id || "default"}
            mb="2"
            padding="16px 24px 16px 24px"
            bgColor={colorMode === "light" ? "gray.100" : "gray.700"}
            borderRadius="md"
          >
            <Flex flexDirection="row" alignItems="center">
              <Flex width="300px" align="center">
                <EditableText
                  onSave={(newValue) =>
                    updateTemplateField(template, "name", newValue)
                  }
                  initialValue={template.name}
                  placeholder="Name"
                  editable={template.bid === bid}
                  pattern={/[^\ ]{3,}/}
                  invalid="more than 3 character."
                />
              </Flex>
              {template.updated && (
                <Flex width="250px" justify="flex-end" pr="20px"  ml="auto">
                  Updated: {moment(template.updated).format("LLL")}
                </Flex>
              )}
              <Flex justifyContent="flex-end" ml="auto">
                {template._id === activeTemplateId ? (
                  <Button isDisabled>Active</Button>
                ) : (
                  <Button onClick={() => makeTemplateActive(template._id)}>Make Active</Button>
                )}
                <Button ml={2} onClick={()=>{
                  const newSearchParams = new URLSearchParams(
                    window.location.search
                  );
                  navigate(`/settings/history/${template._id}?${newSearchParams.toString()}`)
                }}>Edit</Button>
              </Flex>
            </Flex>
          </Box>
        ))}
      </Flex>
    </Box>
  );
}

export default History;
